<div class="card mt-4">
  <div class="card-header text-center"><small><b>Main Seal Materials</b></small></div>
  <div class="card-body">
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th><small>Seal Material</small></th>
          <th><small>Part Number</small></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of sealMaterialsWithFootnotes.seals">
          <td><span class="me-2">
              <small>{{item.sealMaterial}}</small>
            </span></td>
          <td><span class="ms-2"><small>{{item.partNumber}}</small></span></td>
        </tr>
      </tbody>

    </table>

    <div class="d-flex flex-column">
        <ng-container *ngFor="let footnote of sealMaterialsWithFootnotes.footnotes">
          <div class="d-flex">
            <small class="me-2">{{footnote.notation}}</small>
            <small class="text-nowrap">{{footnote.note}}</small>
          </div>
        </ng-container>
    </div>
  </div>
</div>
